<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct && !this.isAmericanCitizen(this.application)"></app-protected-information>
<form #form="ngForm" (ngSubmit)="form.form.valid && onSubmit()" novalidate>
  <div class="container">

    <div class="row mt-3 justify-content-center">
      <div class="col-12 col-md-6">
        <div class="form-group text-center">
          <p>{{ "onboarding.usa-ids.ssn" | translate: {Default: "¿Tienes un número de Seguridad Social de USA?"} }}</p>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="userSSN" [value]="true" [(ngModel)]="application.body.hasSocialSecurityNumber" #userSSN="ngModel" [ngClass]="inputFieldCss(userSSN, form)" required>
            <label class="form-check-label">{{ "onboarding.usa-ids.yes" | translate: {Default: "Sí"} }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="userSSN" (click)="application.body.socialSecurityNumber = undefined" [value]="false" [(ngModel)]="application.body.hasSocialSecurityNumber" #userSSN="ngModel" [ngClass]="inputFieldCss(userSSN, form)" required>
            <label class="form-check-label">{{ "onboarding.usa-ids.no" | translate: {Default: "No"} }}</label>
          </div>
          <app-field-error-display [control]="userSSN" [form]="form"></app-field-error-display>
        </div>
      </div>
    </div>

    <div *ngIf="application.body.hasSocialSecurityNumber" class="row justify-content-center">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="nss"><span>USA SS# </span></label>
          <input type="text" class="form-control" id="nss" name="nss" [(ngModel)]="application.body.socialSecurityNumber" #nss="ngModel" (ngModelChange)="resetNSS(); validateNss()" [ngClass]="inputFieldCss(nss, form)" (blur)="validateNss()" [required]="!application.body.driverLicenseNumber" minlength="9" maxlength="9" numbers>
          <p class="small m-0">{{ "onboarding.usa-ids.SSNinfo" | translate: {Default: "Ingresa tu Número de Seguro Social de USA"} }}</p>
          <app-field-error-display [control]="nss" [form]="form"></app-field-error-display>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <button *ngIf="!this.application.body.applicationRejected" class="btn btn-secondary" type="button" (click)="onBack()">{{ "onboarding.usa-ids.back" | translate: {Default: "Regresar"} }}</button>
    <button class="btn btn-primary float-right" type="button" (click)=" ( application.body.hasSocialSecurityNumber) ? displayConfirm = true : onSubmit()" [disabled]="!form.form.valid">{{ "onboarding.usa-ids.continue" | translate: {Default: "Continuar"} }}</button>
  </div>

</form>

<p-dialog header=" " [(visible)]="displayConfirm" [modal]="true" [baseZIndex]="10000">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <i class="fas fa-exclamation-circle fa-2x notification-circle-icon"></i>
    <p>{{ "onboarding.usa-ids.dataConfirmation" | translate: {Default: "¿Tu Número de Seguridad Social de USA es correcto?"} }}</p>
    <p>{{application.body.socialSecurityNumber}}</p>
  </div>
  <div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-yesno-width" (click)="displayConfirm = false">{{ "onboarding.usa-ids.no" | translate}}</button>
    <button type="button" class="btn btn-outline-success ml-3 btn-yesno-width" (click)="onSubmit();displayConfirm = false">{{ "onboarding.usa-ids.yes" | translate}}</button>
  </div>
</p-dialog>